import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { AppAutocompleteComponent } from '../autocomplete/autocomplete.component';

@Component({
  // TODO: remove all usages of the previous app-tags and rename to app-tags
  // TODO: clean up app-tags-3 from style files
  selector: 'app-tags-2',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTagsComponent<T> {
  @Input('ctx') private readonly _ctx: AppTagsComponent.IContext<T>;

  get values$() {
    return this._ctx.values$;
  }

  get autocompleteCtx(): AppAutocompleteComponent.IContext<T> {
    return this._ctx;
  }

  optionTitle(item: T) {
    return this._ctx.optionTitle(item);
  }

  add() {
    if (!this._ctx.control.value) {
      return;
    }

    this._ctx.onAdd(this._ctx.control.value);
  }

  delete(index: number) {
    this._ctx.onRemove(index);
  }
}

export namespace AppTagsComponent {
  export interface IContext<T> extends AppAutocompleteComponent.IContext<T> {
    readonly values$: Observable<Array<T>>;
    readonly onAdd: (value: string) => void;
    readonly onRemove: (index: number) => void;
  }
}
